<template>
  <div class="section">
    <slot name="header">

    </slot>

    <slot name="category">

    </slot>
  </div>
</template>

<script>
export default {
  name: 'ServiceCategory',
};
</script>

<style lang="scss" scoped>
.section {
  width: max-content;

  display: flex;
  flex-direction: column;
}


@media screen and (max-width: 1024px) {
  .section {
    width: 100%;
  }
}

</style>



// WEBPACK FOOTER //
// src/spa/components/board/service/ServiceCategory.vue